import { createSelector } from "reselect";

import type { FiCatalogResponse } from "@mapmycustomers/shared/types/entity/fieldInsight";

import { RootState } from "@app/store/rootReducer";

const getEntityMentionsState = (state: RootState) => state.component.entityMentions;

export const isMentionChartsLoading = (state: RootState) =>
  getEntityMentionsState(state).chartsLoading;

export const getMentionChartsOrganizationId = (state: RootState) =>
  getEntityMentionsState(state).chartsOrganizationId;

// Keyed by chart id for `@chart:<id>` markers. Its input is the one field
// rather than the whole slice, so a search keystroke elsewhere in the slice
// doesn't rebuild the map and re-render every pill on screen.
export const getChartMentionNames = createSelector(
  (state: RootState) => getEntityMentionsState(state).charts,
  (charts): ReadonlyMap<FiCatalogResponse["id"], string> =>
    new Map(charts.map(({ id, name }) => [id, name]))
);

export const getEntityMentionSearchResults = createSelector(
  getEntityMentionsState,
  ({ searchResults }) => searchResults
);

export const getEntityMentionSearchLoading = createSelector(
  getEntityMentionsState,
  ({ searchLoading }) => searchLoading
);

export const getEntityMentionSearchedQuery = createSelector(
  getEntityMentionsState,
  ({ searchedQuery }) => searchedQuery
);
